module.exports = __webpack_public_path__ + "img/Dantam Hair 28.63f0b8c7.jpg";